import { ShopBarbersQuery, ValidatePasscodeMutation } from '@water-web/api';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const BarberServiceConstructor = (apiUrl: string) => ({
  getByShopId: new ShopBarbersQuery(apiUrl),
  validatePasscode: new ValidatePasscodeMutation(apiUrl),
});
